/* import __COLOCATED_TEMPLATE__ from './company-profile-header.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { htmlSafe } from '@ember/template';

/**
 * Different counts for the truncation of the description string on different browser sizes.  This is to get
 * multi-line support then adding ellipses rather than just having browser do this on a single line.
 *
 * @type {number}
 */
const DESCRIPTION_CHARACTER_TRUNCATE_COUNT_MOBILE = 50;
const DESCRIPTION_CHARACTER_TRUNCATE_COUNT_MEDIUM_AND_DOWN = 200;
const DESCRIPTION_CHARACTER_TRUNCATE_COUNT_LARGE_AND_UP = 250;

const HEADER_CLASS = 'company-profile-seller-view__header';

export default class CompanyProfileHeader extends Component {
  @service session;
  @service media;

  @tracked isDescriptionFullyExpanded = false;

  get className() {
    return HEADER_CLASS;
  }

  get isInNetwork() {
    return this.args.currentCompanyConnection?.invited ?? false;
  }

  get description() {
    let descriptionText = this.args.company.description;

    if (this.isDescriptionFullyExpanded) {
      return htmlSafe(descriptionText);
    }

    if (this.media.isMobile && descriptionText.length > DESCRIPTION_CHARACTER_TRUNCATE_COUNT_MOBILE) {
      descriptionText = descriptionText.slice(0, DESCRIPTION_CHARACTER_TRUNCATE_COUNT_MOBILE) + '...';
    }
    else if (this.media.isMediumAndDown && descriptionText.length > DESCRIPTION_CHARACTER_TRUNCATE_COUNT_MEDIUM_AND_DOWN) {
      descriptionText = descriptionText.slice(0, DESCRIPTION_CHARACTER_TRUNCATE_COUNT_MEDIUM_AND_DOWN) + '...';
    }
    else if (descriptionText.length > DESCRIPTION_CHARACTER_TRUNCATE_COUNT_LARGE_AND_UP) {
      descriptionText = descriptionText.slice(0, DESCRIPTION_CHARACTER_TRUNCATE_COUNT_LARGE_AND_UP) + '...';
    }

    return htmlSafe(descriptionText);
  }

  get isDescriptionTruncated() {
    const descriptionTextLength = this.args.company.description.length;

    const isTruncatedMobile = this.media.isMobile
      && descriptionTextLength > DESCRIPTION_CHARACTER_TRUNCATE_COUNT_MOBILE;
    const isTruncatedMediumAndDown = this.media.isMediumAndDown
      && descriptionTextLength > DESCRIPTION_CHARACTER_TRUNCATE_COUNT_MEDIUM_AND_DOWN;
    const isTruncatedLargeAndUp = descriptionTextLength > DESCRIPTION_CHARACTER_TRUNCATE_COUNT_LARGE_AND_UP;

    return isTruncatedMobile || isTruncatedMediumAndDown || isTruncatedLargeAndUp;
  }

  get backgroundButtonText() {
    return this.isDescriptionFullyExpanded ? 'Show less' : 'Read more';
  }

  @action
  onShowMoreOrLessClicked(e) {
    e.stopPropagation();
    e.preventDefault();
    this.isDescriptionFullyExpanded = !this.isDescriptionFullyExpanded;
  }
}
